<template>
    <div class="footer-main">
        <div class="footer">
            <div class="content-center">
                <div class="footer-center">
                <div class="top">
                    <div class="left">
                    <img loading="lazy"  class="logo" src="../../../static/img/logo/footerLogo.png" alt="">
                    <div class="services">Providing you with the most professional group tour services</div>
                    </div>
                    <div class="right">
                        <div class="phone info-common">
                            <img loading="lazy"  src="../../../static/img/footer/calling.png" alt="">
                        <div class="info">{{footerInfo.phone}}</div>
                        </div>
                        <div class="email info-common">
                            <img loading="lazy"  src="../../../static/img/footer/gmail.png" alt="">
                            <div class="info">{{footerInfo.email}}</div>
                        </div>
                        <div class="adrees info-common">
                            <img loading="lazy"  src="../../../static/img/footer/location.png" alt="">
                            <div class="info">{{footerInfo.adrees}}</div>
                        </div>
                    </div>
                    <div class="FollowUs">
                        <div class="title">Follow Us</div>
                        <div class="img">
                            <img loading="lazy"  src="../../../static/img/footer/facebook.png" alt="">
                            <img loading="lazy"  src="../../../static/img/footer/instagram.png" alt="">
                            <img loading="lazy"  src="../../../static/img/footer/twitter.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="center"></div>
                <div class="bottom">
                    <div class="bottom-left">{{footerInfo1.desc1}}</div>
                    <div class="bottom-right">{{footerInfo1.desc2}}</div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import homeInfo from '/js/footer/footer.js'
export default {
    data() {
        return {
            footerInfo:{},
            footerList:[],
            footerInfo1:{}
        }
    },
    created(){
      this.footerInfo = homeInfo.footerInfo
      this.footerList = homeInfo.footerList
      this.footerInfo1 = homeInfo.footerInfo1
    }
}
</script>
<style lang="scss" scoped>
 @import '/style/pc/footer/footer.scss';
 @import '/style/phone/footer/footer.scss';
</style>